import { Dictionary } from '../types/global';

import { URL_RESOURCES } from '../config/constants/urls';

export const buildPathWithParams = (path: string, params: Dictionary<string>) => {
  let finalPath = path;
  Object.keys(params).forEach((key) => {
    finalPath = finalPath.replace(`:${key}`, params[key]);
  });
  return finalPath;
};

export const buildPathWithQueryString = (
  params: Dictionary<string | boolean | number>,
  path?: string,
) => {
  const keysPair = Object.keys(params).map((key) => `${key}=${params[key]}`);
  const queryString = keysPair.join('&');
  return path + `?${queryString}`;
};

export const buildPathKeyValueBase64 = (
  path: string,
  key: string,
  value: Dictionary<string | boolean | number>,
) => {
  const jsonString = JSON.stringify(value);
  return path + `?${key}=${btoa(jsonString)}`;
};

export const makeUrlWithScheme = (url?: string) => {
  if (!url) {
    return '';
  }
  if (url.startsWith('http')) {
    return url;
  }
  return `https://${url}`;
};

export const redirectWithScheme = (url: string) => {
  window.location.href = makeUrlWithScheme(url);
};

export const getQueryParam = (key: string): string | null => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key);
  } catch {
    return null;
  }
};

export const getMerchantImage = (merchantImage: string) =>
  merchantImage ? `${URL_RESOURCES.merchants}wide/${merchantImage}.svg` : defaultImg;

export const getCashOutMethodImage = (cashoutImage: string) =>
  cashoutImage ? `${URL_RESOURCES.refunds}${cashoutImage}.svg` : defaultImg;

export const getPaymentMethodImage = (paymentMethodCode: string) =>
  paymentMethodCode ? `${URL_RESOURCES.paymentMethods}${paymentMethodCode}.svg` : defaultImg;

export const getChannelImage = (channel: string) =>
  channel ? `${URL_RESOURCES.channels}${channel}.svg` : defaultImg;

export const getCurrencyImage = (currency: string) =>
  currency ? `${URL_RESOURCES.currrencies}${currency}.svg` : defaultImg;

export const getFlagImage = (country: string) =>
  country ? `${URL_RESOURCES.flags}${country}.svg` : defaultImg;

const defaultImg = '';
